import { updateDepartureInfo } from '@/api';
import Input from '@/components/common/Input';
import ReceiptLayout from '@/components/common/ReceiptLayout';
import { routes } from '@/constant/routes.const';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { ICON_CALENDAR2 } from '@repo/assets';
import { CalendarModal, TextButton } from '@repo/components';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

export type DeparturePayload = {
  departureDate: string;
  passportNumber: string | null;
  email?: string;
};

const DepartureDate = () => {
  const {
    passportNumber,
    nationality,
    register,
    refundCondition,
    firstRefundDate,
  } = useAppSelector((state) => state) as IGlobalState;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const [departureDate, setDepartureDate] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState<any>({ message: '' });

  const { mutate: departureMutation } = useMutation(
    ['deaprtureDate'],
    (payload: DeparturePayload) => updateDepartureInfo(payload),
    {
      onSuccess: () => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            email,
            departureDate,
          },
        });
        if (register) {
          history.push(routes.home);
        } else {
          history.push(routes.customerRefund);
        }
      },
      onError: () => {
        alert('서버와 통신이 원활하지 않습니다.');
      },
    },
  );

  const handleSubmit = () => {
    const emailRegex =
      /[a-zA-Z0-9]{1,}@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    if (!emailRegex.test(email)) {
      setEmailError({
        message:
          nationality === 'KOR'
            ? '이메일 형식이 아닙니다.'
            : 'Please enter a valid email address.',
      });
      return;
    }
    departureMutation({
      email,
      passportNumber,
      departureDate: departureDate
        ? format(new Date(departureDate), 'yyyy-MM-dd')
        : format(new Date(), 'yyyy-MM-dd'),
    });
  };

  return (
    <ReceiptLayout>
      <TitleWrapper>
        {nationality === 'KOR' ? (
          <>
            <Strong>{passportNumber}</Strong> 님 환영합니다!
          </>
        ) : (
          <>
            Welcome! <Strong>{passportNumber}</Strong>
          </>
        )}
        <Contents>
          {nationality === 'KOR'
            ? '출국일을 입력해주세요.'
            : 'Please enter the Email.'}
        </Contents>
      </TitleWrapper>
      <DevideLine />
      {refundCondition !== 'REFUND_ONLY' && (
        <InputWrapper onClick={() => setIsOpenCalendar(true)}>
          <Input
            value={departureDate && format(new Date(departureDate), 'yy-MM-dd')}
            label={nationality === 'KOR' ? '출국일' : 'Departure Date'}
            isRequired
            placeholder='YY-MM-DD'
            width='335px'
            style={{ cursor: 'pointer', backgroundColor: '#ffffff' }}
            readOnly
          />
          <CalendarIcon src={ICON_CALENDAR2} />
        </InputWrapper>
      )}
      <InputWrapper>
        <Input
          label='E-Mail'
          isRequired
          placeholder='ex) abc@email.com'
          width='335px'
          margin={[0, 0, 20]}
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          error={emailError.message && emailError}
        />
      </InputWrapper>
      <TextButton
        title={nationality === 'KOR' ? '다음' : 'CHECK'}
        bottomFixed
        onClick={handleSubmit}
      />
      {isOpenCalendar && (
        <CalendarModal
          nationality={nationality}
          departureDate={departureDate}
          firstRefundDate={firstRefundDate}
          onChange={setDepartureDate}
          onClose={() => setIsOpenCalendar(false)}
          onClick={() => setIsOpenCalendar(false)}
        />
      )}
    </ReceiptLayout>
  );
};

export default DepartureDate;

const TitleWrapper = styled.div`
  color: #3a3b3e;
  font-size: 22px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.44px;
  width: 100%;
  margin-top: 24px;
`;

const Strong = styled.strong<{ color?: string }>`
  color: #246cf6;
`;

const Contents = styled.p`
  color: #3a3b3e;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
`;

const DevideLine = styled.hr`
  width: 100%;
  margin: 24px 0;
`;

const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
  position: relative;
`;

const CalendarIcon = styled.img`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
  top: 55px;
  cursor: pointer;
`;
